<!--
 * @Author: guoyu
 * @Date: 2020-06-22 12:25:46
 * @LastEditors: your name
 * @LastEditTime: 2020-06-23 11:30:22
 * @Description: 进程步骤组件
-->
<template>
  <div>
    <div
      class="progress-box"
      v-for="(item, index) in computedSteps"
      :key="index + 'step'"
    >
      <div>
        <slot name="step" :active="currentIndex >= index" :item="item">
          <div class="progress-dot-box">
            <span
              class="progress-dot"
              :class="{ 'active-dot': item.isActive }"
              :style="{
                background: item.isActive ? activeDotColor : defaultDotColor,
              }"
            ></span>
          </div>
          <div
            class="progress-line"
            :style="{
              'border-left': item.isActiveLine ? aciveLine : defaultLine,
            }"
          ></div>
        </slot>
      </div>
      <div>
        <slot :actived="item.isActive" :item="item">
          {{ item.label || item[valKey] }}
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgressStep',
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    currentStatus: {
      type: [String, Number],
      default: 0,
    },
    activeDotColor: {
      type: String,
      default: 'linear-gradient(#FF4417, #FB006E)',
    },
    defaultDotColor: {
      type: String,
      default: '#BBBBBB',
    },
    activeColor: {
      type: String,
      default: '#FB006E',
    },
    defaultColor: {
      type: String,
      default: '#BBBBBB',
    },
    valKey: {
      type: String,
      default: 'value',
    },
  },
  computed: {
    currentIndex() {
      return this.steps.findIndex(item => {
        let val = typeof item === 'object' ? item[this.valKey] : item;
        return this.currentStatus === val;
      });
    },
    computedSteps() {
      return this.steps.map((item, index) => {
        if (typeof item !== 'object') {
          item = { [this.valKey]: item };
        }
        return {
          ...item,
          isActive: this.currentIndex >= index,
          isActiveLine: this.currentIndex >= index + 1,
        };
      });
    },
    aciveLine() {
      return `1px solid ${this.activeColor}`;
    },
    defaultLine() {
      return `1px dashed ${this.defaultColor}`;
    },
  },
};
</script>
<style scoped>
.progress-box {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  font-size: 16px;
  color: #333333;
}
.progress-dot-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 27px;
  width: 15px;
}
.progress-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.active-dot {
  width: 15px;
  height: 15px;
  box-shadow: 0px 1px 4px rgba(250, 0, 110, 0.35);
}
.progress-line {
  flex-grow: 1;
  width: 0;
  min-height: 30px;
  margin: auto;
}
.progress-box:last-child .progress-line {
  display: none;
}
</style>
